<div class="form-container" style="position: relative">
  <div class="grid-toolbar">
    <div class="grid-toolbar-container">
      <div class="grid-toolbar-body">
        <ul class="toolbar-list">
          <li
            class="toolbar-list-item"
            (click)="saveTemplate()"
            *ngIf="mode === 'sortable'"
          >
            <div class="list-button">
              <span class="list-icon">
                <i class="fal fa-save"></i>
              </span>
              <span class="list-item-title">{{
                "save_template" | translate
              }}</span>
            </div>
          </li>
          <li
            class="toolbar-list-item"
            (click)="commitSave('SAVE')"
            *ngIf="mode === 'add' || mode === 'edit' || mode === 'copy'"
          >
            <div class="list-button">
              <span class="list-icon">
                <i class="fal fa-save"></i>
              </span>
              <span class="list-item-title">{{
                (mode === "add" ? "save" : mode === "copy" ? "save" : "edit")
                  | translate
              }}</span>
            </div>
          </li>
          <li
            class="toolbar-list-item"
            (click)="commitSave('SAVE_NEW')"
            *ngIf="(mode === 'add' || mode === 'copy') && saveAndNew"
          >
            <div class="list-button">
              <span class="list-icon">
                <i class="fal fa-save"></i>
              </span>
              <span class="list-item-title">{{
                "save_and_new" | translate
              }}</span>
            </div>
          </li>
          <li class="toolbar-list-item" *ngIf="processButtons">
            <div class="list-button">
              <span class="list-icon"> </span>
              <span class="list-item-title">{{ "processes" | translate }}</span>
              <div dropdown container="body" class="list-dropdown">
                <button
                  dropdownToggle
                  type="button"
                  class="btn btn-sm list-dropdown-button"
                >
                  <i class="fal fa-angle-down" aria-hidden="true"></i>
                </button>
                <ul
                  class="dropdown-menu toolbar-dropdown-menu toolbar-dropdown-menu"
                  role="menu"
                  *dropdownMenu
                >
                  <li
                    role="menuitem"
                    *ngFor="let process of processButtons"
                    (click)="process.method()"
                  >
                    <span class="list-head"></span>
                    <a
                      class="dropdown-item"
                      [class.dropdown-submenu]="process.children"
                      >{{ process.slug | translate }}
                      <ul class="dropdown-menu" *ngIf="process.children">
                        <li
                          *ngFor="let childInitState of process.children"
                          (click)="childInitState.method()"
                        >
                          <span class="list-head"></span>
                          <a class="dropdown-item">{{
                            childInitState.slug | translate
                          }}</a>
                        </li>
                      </ul>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li
            class="toolbar-list-item"
            *ngFor="let button of buttons"
            (click)="button.method()"
          >
            <div class="list-button">
              <span class="list-icon">
                <i class="fa" [ngClass]="button.icon"></i>
              </span>
              <span class="list-item-title">{{ button.slug | translate }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="col-md-12 col-sm-12 form-header" *ngIf="title">
    <div class="left-group">
      <span class="title">{{ title }}</span>
      <div class="form-header-alert">
        <kl-alert
          [show]="alertShow"
          [message]="alertMessage"
          [type]="alertType"
          (onClose)="closeAlert()"
        ></kl-alert>
      </div>
    </div>
  </div>
  <ng-content></ng-content>
</div>
